module.exports = __webpack_public_path__ + "img/shoplogo.ff3abac7.svg";